export default __webpack_public_path__ + "static/media/greenLogo.2105e2aa.png";